import AppLogo from '@components/AppLogo';
import { API_BASE_URL, IS_ANONYMOUS_APP, MAIN_APP_SIGNUP_URL } from '@config/config';
import { useAppSelectors } from '@stores/app/appStore';

const DemoModeBubble = () => {
  const demoMode = useAppSelectors.demoMode();
  if (!IS_ANONYMOUS_APP && !demoMode) return null;

  const signupUrl = `${MAIN_APP_SIGNUP_URL}?from_demo=1`;

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    // Clear auth cookies via backend (anon_access_token is httpOnly)
    try {
      await fetch(`${API_BASE_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch { /* best-effort */ }
    window.location.href = signupUrl;
  };

  return (
    <div
      className="min-w-fit z-[0] flex items-center px-4 py-2 rounded-xl bg-neutral-900 text-white shadow-lg border border-gray-700 overflow-hidden pointer-events-auto"
      data-attr-demo-mode-bubble
    >
      <AppLogo compact size={16} className="!h-[16px] flex-shrink-0" logoClassName="brightness-0 invert" displayLeoLogo />
      <div className="h-4 w-px flex-shrink-0 bg-gray-600 mx-2" aria-hidden />
      <span className="text-sm text-gray-200 whitespace-nowrap mr-1">
        <span className="hidden sm:inline">You're in demo mode,</span>
        <span className="sm:hidden">Demo mode</span>
      </span>
      <a
        href={signupUrl}
        onClick={handleClick}
        className="text-sm font-medium text-primary hover:text-primary no-underline hover:underline underline-offset-2 whitespace-nowrap flex-shrink-0"
        data-attr-demo-mode-create-account
      >
        create your account
      </a>
    </div>
  );
};

export default DemoModeBubble;
